import $ from 'jquery';
import ScrollController from './ScrollController';
import '../vendor/dotimeout/jquery.ba-dotimeout.min';

const defaults = {
  delay: 400,
  selectors: {
    menu: '.menu-icon',
    search: '.search-icon',
    text: '#edit-box-text',
    input: '#edit-keywords',
  },
};

function Toolbar(element, context, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = $.extend(true, defaults, options);
  this.$body = this.getBody(context);
  this.$menuBtn = this.getBtn('menu');
  this.$searchBtn = this.getBtn('search');
  this.$searchBox = this.getBox(context);
  this.searchText = this.getText(context);
  this.menuHandler = $.proxy(this.menuHandler, this);
  this.searchHandler = $.proxy(this.searchHandler, this);
  this.resetSearchInput = $.proxy(this.resetSearchInput, this);
  this.scrollController = this.addScrollController();
  this.addListeners();
}

Toolbar.prototype = {
  getBody(context) {
    return $(document.body, context);
  },
  getBtn(type) {
    return $(this.settings.selectors[type], this.element);
  },
  getText(context) {
    const $searchText = $(this.settings.selectors.text, context);
    // clear out the value since we don't want it displayed
    const searchText = $searchText.val();
    $searchText.val('');
    return searchText;
  },
  getBox(context) {
    const $input = $(this.settings.selectors.input, context);
    $input.val('');
    return $input;
  },
  addScrollController() {
    const selector = '.header-top';
    const element = document.querySelector(selector);
    return new ScrollController(element, selector);
  },
  menuHandler() {
    const active = this.$body.is('.menu-active, .search-active');
    this.$body.filter('.search-active').removeClass('search-active');
    if (active) {
      this.$body.removeClass('menu-active');
      this.scrollController.enable();
    } else {
      this.$body.addClass('menu-active');
      this.scrollController.disable();
    }
  },
  searchHandler(event) {
    event.stopPropagation();
    const active = this.$body.is('.search-active');
    this.$body.filter('.menu-active').removeClass('menu-active');
    if (active) {
      this.$body.removeClass('search-active');
      this.scrollController.enable();
      // Cancel any search input timeouts that may be running.
      this.$searchBox.doTimeout('focus');
      this.$searchBox.doTimeout('typing');
    } else {
      this.$body.addClass('search-active');
      this.scrollController.disable();
      this.$searchBox.attr('placeholder', '');
      // Focus the search box after a small delay.
      this.$searchBox.doTimeout('focus', 750, () => {
        this.typeOutPlaceholderText();
      });
    }
  },
  typeOutPlaceholderText() {
    let i = 0;
    if (!this.$searchBox.val().length) {
      this.$searchBox.doTimeout('typing', 60, () => {
        if (i <= this.searchText.length) {
          this.$searchBox.attr('placeholder', this.searchText.substr(0, i)).focus();
          i += 1;
          return true;
        }

        return false;
      });
    }
  },
  resetSearchInput() {
    // This is a workaround to overcome the default dd-search.js search
    // input scripted behaviors.
    if (this.searchText === this.$searchBox.val()) {
      this.$searchBox.val('');
    }
  },
  addListeners() {
    this.$menuBtn.bind('click', this.menuHandler);
    this.$searchBtn.bind('click', this.searchHandler);

    // Listening so that we can override previously set scripted behaviors.
    this.$searchBox.bind('blur focus', this.resetSearchInput);
  },
};

export default Toolbar;



// WEBPACK FOOTER //
// ./Toolbar.js